import React, { useEffect, useState } from "react";
import { getAnnouncements, deleteAnnouncement } from "services/announcements";
import Card from "components/card";
import Button from "components/button";
import { useNavigate } from "react-router-dom";

interface Announcement {
  id: number;
  title: string;
  content: string;
  creator?: { fullName?: string };
  created_at?: string;
}

const Announcements = () => {
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await getAnnouncements();
        setAnnouncements(Array.isArray(data?.data) ? data.data : []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleDelete = async (id: number) => {
    if (!window.confirm("Are you sure?")) return;
    try {
      await deleteAnnouncement(id);
      setAnnouncements((prev) => prev.filter((a) => a.id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Card extra="w-full p-4">
      <div className="mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <h2 className="text-2xl font-bold text-gray-900">Announcements</h2>
        <div className="mt-3 sm:mt-0">
          <Button as="link" to="/admin/announcements/create">
            Create Announcement
          </Button>
        </div>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : announcements.length === 0 ? (
        <p className="py-8 text-center text-gray-500 dark:text-gray-300">
          No announcements yet.
        </p>
      ) : (
        <div className="rounded-lg bg-white shadow dark:bg-navy-700 dark:shadow-none">
          <div className="p-6">
            {announcements.map((announcement) => (
              <div
                key={announcement.id}
                className="mb-6 border-b border-gray-200 pb-6 last:border-0"
              >
                <h3 className="mb-2 text-lg font-semibold text-gray-900">
                  {announcement.title}
                </h3>
                <p className="mb-3 text-gray-700">{announcement.content}</p>
                <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                  <span className="mb-3 text-sm text-gray-500 md:mb-0">
                    Posted {announcement.created_at} by{" "}
                    {announcement.creator?.fullName}
                  </span>
                  <div className="flex items-center space-x-2">
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() =>
                        navigate(`/admin/announcements/${announcement.id}/edit`)
                      }
                    >
                      Edit
                    </Button>
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => handleDelete(announcement.id)}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </Card>
  );
};

export default Announcements;
